import React, { useState } from 'react';
import * as yup from 'yup';
import { SingleRadio } from '@youngcapital/component-library';
import { validEndDate, validLinkedInUrl } from '@youngcapital/validations';
import { isMobile } from 'is-mobile';

import { asFieldset, FIELDSET_PROPTYPES } from '../asFieldset';
import WorkExperiences from './WorkExperiences';
import FileInput from './FileInput';
import LinkedInUrlComponent from './LinkedInUrlComponent';
import { localStorageHandler } from './helpers';
import { CV_FIELDSET_INITIAL_VALUES } from './constants';

const makeRadioPropsGetter =
  (radioSelected, setRadioSelected, getFieldProps) => id => ({
    id: `cv-${id}`,
    value: id,
    name: 'cv_radios',
    checked: id === radioSelected,
    onChange: () => {
      localStorageHandler({
        getFieldProps,
        previousRadioId: radioSelected,
        setRadioSelected,
        nextRadioId: id
      });
    }
  });

const CvFieldset = ({ getFieldProps, t }) => {
  const [radioSelected, setRadioSelected] = useState(0);
  const getRadioProps = makeRadioPropsGetter(
    radioSelected,
    setRadioSelected,
    getFieldProps
  );

  const currentFile = getFieldProps('linkedin_profile_link');
  const shouldRenderFileUpload = radioSelected === 1 && currentFile;

  return (
    <>
      <h3 className='mb-2x'>{t('cv_fieldset.my_cv')}</h3>
      <SingleRadio
        label={t('cv_fieldset.add_later')}
        {...getRadioProps(0)}
        inputProps={{
          title: 'add-later-radio'
        }}
      />
      {!isMobile() && (
        <SingleRadio
          label={t('cv_fieldset.upload_cv')}
          {...getRadioProps(1)}
          inputProps={{
            title: 'add-upload-cv-radio'
          }}
        />
      )}
      {shouldRenderFileUpload && (
        <FileInput getFieldProps={getFieldProps} t={t} />
      )}
      <SingleRadio
        label={t('cv_fieldset.want_linkedin_url')}
        {...getRadioProps(2)}
        inputProps={{
          title: 'add-linkedin-radio'
        }}
      />
      {radioSelected === 2 && (
        <LinkedInUrlComponent getFieldProps={getFieldProps} t={t} />
      )}
      <SingleRadio
        label={t('cv_fieldset.add_manually')}
        {...getRadioProps(3)}
        inputProps={{
          title: 'add-manually-radio'
        }}
      />
      {radioSelected === 3 && (
        <WorkExperiences getFieldProps={getFieldProps} t={t} />
      )}
    </>
  );
};

CvFieldset.type = 'cv';

CvFieldset.propTypes = FIELDSET_PROPTYPES;

CvFieldset.initialValues = () => ({
  ...CV_FIELDSET_INITIAL_VALUES
});

CvFieldset.validationSchema = () => ({
  linkedin_profile_link: validLinkedInUrl(),
  work_experiences: yup.array().of(
    yup.object().shape({
      company: yup.string().required(),
      function_title: yup.string().required(),
      city: yup.string().required(),
      date_start: yup.string().required(),
      date_end: yup.mixed().when('current_job', {
        is: true,
        then: yup.mixed().nullable(),
        otherwise: validEndDate(yup.ref('date_start')).required()
      }),
      current_job: yup.boolean(),
      is_agency: yup.boolean()
    })
  )
});

export default asFieldset(CvFieldset);
